import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { FaGlobe } from 'react-icons/fa';
import { useAuthContext } from "../../../../../components/providers/AuthProvider.jsx";
import {toast} from "react-toastify";
import {getThemeContext} from "../../../../../components/providers/ThemeProvider.jsx";

// Función auxiliar para concatenar clases condicionalmente
function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const TokensDropdown = ({ modelo }) => {
    const authContext = useAuthContext();
    // Mostrar el dropdown solo si el rol es "admin" y existe al menos un token.
    if (authContext.role !== "admin" || !modelo.tokens || modelo.tokens.length === 0) {
        return null;
    }

    const now = new Date();
    // Verificar si existe algún token vigente:
    // - Debe no haber expirado: new Date(token.expires_at) > now
    // - Y debe cumplirse la condición de uso: si max_usage es 0, se ignora, o sino usage_count < max_usage
    const hasActiveToken = modelo.tokens.some(token => {
        return new Date(token.expires_at) > now &&
            (token.max_usage === 0 || token.usage_count < token.max_usage);
    });

    // Color del badge principal: verde (success) si hay algún token activo, sino naranja (warning)
    const badgeColor = hasActiveToken ? 'badge-success' : 'badge-warning';



    const theme = getThemeContext(); // Obtener el tema actual del contexto
    const handleCopyURLToken = (token) => {
        const url = `${window.location.origin}/${token.url_token}`;
        navigator.clipboard.writeText(url)
            .then(() => {
                toast.success('URL copiada al portapapeles', {
                    theme: theme === 'dark' ? 'dark' : 'light',
                });            })
            .catch(err => {
                console.error('Error copying URL:', err);
            });
    }
    return (
        <div className="absolute top-2 left-2 z-10 inline-block text-left">
            <Menu>
                <Menu.Button className={`badge badge-soft p-1 ${badgeColor}`}>
                    <FaGlobe />
                </Menu.Button>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="origin-top-left absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-base-100 ring-1 ring-black ring-opacity-5 focus:outline-none z-30">
                        <div className="py-1">
                            {modelo.tokens.map(token => {
                                // Evaluar si el token está vigente usando la lógica actualizada
                                const tokenActive = new Date(token.expires_at) > now &&
                                    (token.max_usage === 0 || token.usage_count < token.max_usage);
                                const tokenBadgeColor = tokenActive ? 'badge-success' : 'badge-warning';

                                return (
                                    <Menu.Item key={token.id}>
                                        {({ active }) => (
                                            <button
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'w-full text-left px-4 py-2 flex items-center'
                                                )}
                                                onClick={() => handleCopyURLToken(token)}
                                            >
                                                <span className={`badge ${tokenBadgeColor} mr-2`}>
                                                    {tokenActive ? 'Vigente' : 'No vigente'}
                                                </span>
                                                <span>Token #{token.id}</span>
                                            </button>
                                        )}
                                    </Menu.Item>
                                );
                            })}
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    );
};

export default TokensDropdown;
